import * as yup from 'yup';

export const initialValuesStepThree = {
  phone: '',
  betweenStreets: '',
  additionalReferences: '',
};

export const initialTouchedStepThree = {
  phone: true,
  betweenStreets: true,
  additionalReferences: true,
};

export const schemaStepThree = yup.object().shape({
  phone: yup.string().required('Requerido').length(10, 'Debe tener 10 dígitos'),
  betweenStreets: yup
    .string()
    .required('Requerido')
    .min(3, 'Mínimo 3 caracteres')
    .max(100, 'Máximo 100 caracteres'),
  additionalReferences: yup
    .string()
    .required('Requerido')
    .min(3, 'Mínimo 3 caracteres')
    .max(100, 'Máximo 100 caracteres'),
});
